import { AnyAction, configureStore, ThunkAction } from "@reduxjs/toolkit";
import asset from "./reducers/asset";
import auth from "./reducers/auth";
import profile from "./reducers/profile";
import dmState from "./reducers/dmState";
import bToCState from "./reducers/bToCState";
import event from "./reducers/event";
import keys from "./reducers/keys";
import layout from "./reducers/layout";
import settings from "./reducers/settings";
import whiteboard from "./reducers/whiteboard";

export const store = configureStore({
  reducer: {
    auth,
    layout,
    asset,
    profile,
    whiteboard,
    keys,
    event,
    dmState,
    bToCState,
    settings,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [],
        // Ignore these paths in the state
        ignoredPaths: [],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type TypedThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  AnyAction
>;
